import { useQuery } from "@tanstack/react-query";
import { controleQuinquennalKeys } from "@src/data/controle-quinquennal/hook/controle-quinquennal.keys";
import { FilesApi } from "../files.api";

export const useZipMetadataQuery = (
  controleQuinquennalId: string | undefined,
  axeId: string | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.zipMetadata(
      controleQuinquennalId ?? "",
      axeId ?? ""
    ),
    queryFn: () => FilesApi.getZipMetadata(controleQuinquennalId!, axeId!),
    enabled:
      Boolean(controleQuinquennalId && axeId) && (options?.enabled ?? true),
    // Données considérées stale immédiatement : à la réouverture de la section
    // (query réactivée) ou au retour sur l'onglet, un refetch automatique
    // vérifie qu'une pièce n'a pas été ajoutée entre-temps.
    staleTime: 0,
  });
};
